import { createSelector } from "@reduxjs/toolkit";

import { selectCurrentUserId } from "../local";

import { selectUserIdsWithCapability } from "./capability";
import { selectIsInPersonClass } from "./info";

import { CapabilityType, RootState } from "shared/types";

export const selectIsPresentationView = () =>
  createSelector(
    [
      selectIsInPersonClass(),
      selectCurrentUserId(),
      selectUserIdsWithCapability(CapabilityType.CAN_CONTROL_CLASSROOM),
    ],
    (isInPerson, userId, canControlClassroomList) => {
      const urlParams = new URLSearchParams(window.location.search);
      const tryingToPresent = urlParams.has("presentation");
      return tryingToPresent && isInPerson && canControlClassroomList?.includes(userId);
    },
  );

export const selectHasPresentationView = (userId?: string) => (state: RootState) => {
  const presentingUserIds = state.classroom.client.presenting_user_ids || [];
  return userId ? presentingUserIds.includes(userId) : presentingUserIds.length > 0;
};
